import React from 'react';
import { 
    Chart as ChartJS, 
    ArcElement, 
    Tooltip, 
    Legend 
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { faker } from "@faker-js/faker";

ChartJS.register(
    ArcElement, 
    Tooltip, 
    Legend
);

const labels = ['여성', '남성'];

const firstNumber = faker.number.int({ min: 0, max: 100 }); // 첫 번째 랜덤 숫자 생성
const secondNumber = 100 - firstNumber; // 두 번째 숫자는 첫 번째 숫자와 합쳐서 100이 되도록 조정

export const data = {
    labels,
    datasets: [
        {
            label: '구매자 통계(단위 : %)',
            data: [firstNumber, secondNumber],
            backgroundColor: [
                '#FFA6A6',
                '#A5D4FD',
            ],
            borderColor: [
                'transparent',
                'transparent',
            ],
            borderWidth: 1,
        },
    ],
};

export const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false // 범례 표시
        },
        tooltip: {
            callbacks: {
                label: function(context) {
                    let label = context.label || ''; // 데이터셋의 라벨 가져오기
                    if (label) {
                        label += ': '; // 라벨과 데이터 사이에 콜론 추가
                    }
                    if (context.parsed !== null) {
                        label += context.parsed + '%'; // 데이터 값에 퍼센트 추가
                    }
                    return label;
                }
            }
        }
    }
};

const DoughChart = () => {
    return <Doughnut data={data} options={options} />;
};

export default DoughChart;